import { createFileRoute } from "@tanstack/react-router";
import { LifeBuoyIcon } from "lucide-react";
import { SupportEditor } from "@/components/admin/support/support-editor";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/support")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "support_feedback"),
  component: AdminSupportPage,
});

function AdminSupportPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <LifeBuoyIcon className="size-3.5" />
          Support
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Support page</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Author the help content shown to every signed-in user on their
            <span className="font-medium"> Support</span> page. Changes go live as soon as you save.
          </p>
        </div>
      </header>

      <SupportEditor />
    </div>
  );
}
